import { useFragment, graphql } from 'react-relay';
import { useIntl, defineMessages } from 'dibs-react-intl';
import { type MeasurementUnit } from 'dibs-intl/exports/units';

import { type useProductDimensions_measurement$key } from './__generated__/useProductDimensions_measurement.graphql';

const measurementFragment = graphql`
    fragment useProductDimensions_measurement on ItemMeasurement {
        display(addLabel: true, separator: " ", fields: [height, width, depth, diameter, length]) {
            unit
            value
        }
        size {
            value
        }
    }
`;

const messages = defineMessages({
    sizeLabel: {
        id: 'dc.buyProductTile.sizeLabel',
        defaultMessage: 'Size: {size}',
    },
});

export const useProductDimensions = ({
    measurement: measurementRef,
    showMeasurements,
    measurementUnit,
}: {
    measurement: useProductDimensions_measurement$key | null | undefined;
    measurementUnit: MeasurementUnit;
    showMeasurements: boolean | null | undefined;
}): { dimensionValues: string; canShowDimensions: boolean } => {
    const { formatMessage } = useIntl();
    const measurement = useFragment(measurementFragment, measurementRef);
    const { display, size } = measurement || {};
    const dimensionValues = size?.value
        ? formatMessage(messages.sizeLabel, { size: size.value })
        : (display || []).find(dimension => dimension?.unit === measurementUnit)?.value || '';

    const canShowDimensions = !!(dimensionValues && showMeasurements);
    return {
        dimensionValues,
        canShowDimensions,
    };
};
